var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"border rounded-sm border-secondary mb-3"},[_c('div',{staticClass:"item-link typo-body-2 d-flex px-3 pt-4 pb-2 text-decoration-none"},[_c('div',{staticClass:"item-info"},_vm._l((_vm.data.items),function(item){return _c('div',{key:item.id,staticClass:"list-item"},[_vm._v(" "+_vm._s(item.id)+" ")])}),0),_c('div',{staticClass:"item-actions"},[_c('span',{staticClass:"item-fee"},[_vm._v(_vm._s(_vm.formatFee))]),_c('router-link',{staticClass:"icon-edit",attrs:{"to":{
					name: 'ShippingPostcodeAdditionalFeeEdit',
					params: {
						shippingMethodId: _vm.data.shippingMethodId,
						feeId: _vm.data.id
					}
				}}},[_c('CIcon',{attrs:{"name":"cil-pencil"}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }